<template>
  <div class="app">
    <AppHeader>
      <SidebarToggler class="d-lg-none" display="md" mobile @click.native="onSidebarTogglerClick" />
      <b-link class="navbar-brand d-md-down-none" to="#">
        <img
          class="navbar-brand-full"
          src="img/brand/TCLogo.png"
          width="134"
          height="37"
          alt="TC Logo"
        />
        <img
          class="navbar-brand-minimized"
          src="img/brand/TCLogo-min.png"
          width="32"
          height="37"
          alt="TC Logo"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" @click.native="onSidebarTogglerClick" />
      <b-navbar-nav class="ml-auto">
        <b-nav-item>
          <b-button
            @click="changeLocale(enLang.language)"
            variant="outline-light"
            size="sm"
          >
            <i class="flag-icon flag-icon-gb flag-icon-squared" size="sm"></i>
          </b-button>
          <b-button
            @click="changeLocale(czLang.language)"
            variant="outline-light"
            size="sm"
          >
            <i class="flag-icon flag-icon-cz flag-icon-squared" size="sm"></i>
          </b-button>
        </b-nav-item>
        <b-nav-text readonly class="ml-2 mr-1 header-user text-truncate">
          <span class="d-none d-md-inline">{{ user.fullname }} (</span>{{ user.username }}<span class="d-none d-md-inline">)</span>
        </b-nav-text>
        <i class="icon-user ml-1 mr-2"></i>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="navItems"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <div class="container-fluid">
          <!-- this is router where children are showed -->
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<style scoped>
.app-body {
  flex: 1;
  min-height: 0;
}
.main {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.main .container-fluid {
  padding: 0;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
</style>

<script>
import { i18n } from "@/_plugins/i18n";
import { applyMenuVisibility, isMenuShown, revealMenuManually } from "@/_helpers";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav
} from "@coreui/vue";

export default {
  name: "DefaultContainer",
  components: {
    AppHeader,
    AppSidebar,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
        user: {},
      enLang: { language: "en", title: "English" },
      czLang: { language: "cs", title: "Česky" }
    };
  },
    created() {
        this.user = JSON.parse(localStorage.getItem("viewer-user"));
        applyMenuVisibility(this.$route);
    },
    mounted() {
        this.$nextTick(() => applyMenuVisibility(this.$route));
    },
    watch: {
      $route() {
        applyMenuVisibility(this.$route);
      }
    },
  computed: {
      navItems() {
          return [
              {
                  title: true,
                  name: this.$i18n.t("mainMenu.mainMenu"),
                  class: '',
                  wrapper: {
                      element: '',
                      attributes: {}
                  }
              },
              {
                  name: this.$i18n.t("mainMenu.myProjects"),
                  url: '/projects',
                  icon: 'icon-layers'
              },
              {
                  title: true,
                  name: this.$i18n.t("mainMenu.userMenu"),
                  class: '',
                  wrapper: {
                      element: '',
                      attributes: {}
                  }
              },
              {
                  name: this.$i18n.t("mainMenu.settings"),
                  url: '/settings',
                  icon: 'icon-settings'
              },
              {
                  name: this.$i18n.t("mainMenu.manual"),
                  url: '/manual',
                  icon: 'icon-question'
              },
              {
                  name: this.$i18n.t("mainMenu.logout"),
                  url: '/login',
                  icon: 'icon-logout'
              }
          ]
      },
      name() {
          return this.$route.name;
      },
      list() {
          return this.$route.matched.filter(
            route => route.name || route.meta.label
          );
      }
  },
  methods: {
    changeLocale(locale) {
      i18n.locale = locale;
    },
    onSidebarTogglerClick() {
      if (
        document.body.classList.contains("viewer-menu-hidden") ||
        !isMenuShown(this.$route)
      ) {
        revealMenuManually(this.$router);
      }
    }
  }
};
</script>
